/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Section Header
 */

import { Container, Row } from 'react-bootstrap';

// Styles
import './style.scss';

const SectionHeader = (props) => {
    const sectionHeader = props.sectionHeader;

    return(
        <Container>
            <Row>
                <div
                    className="section-header__title"
                    data-aos="fade-up"
                >
                    <h1>{sectionHeader.title}</h1>
                    <p>{sectionHeader.text}</p>
                </div>
            </Row>
        </Container>
    );
}

export default SectionHeader;
